import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SpinnerSize } from './spinner-size';
import { SpinnerTheme } from './spinner-theme';

/**
 * The `<app-spinner>` component indicates background activity, such as loading data or uploading files.
 *
 * @example
 * ```HTML
 * <app-spinner size="default" theme="danger"></app-spinner>
 * ```
 */
@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.html',
    styleUrl: './spinner.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'app-spinner',
        'role': 'progressbar',
        '[class.app-spinner--size-default]': 'size() === "default"',
        '[class.app-spinner--size-small]': 'size() === "small"',
        '[class.app-spinner--theme-danger]': 'theme() === "danger"',
        '[class.app-spinner--theme-default]': 'theme() === "default"',
    },
})
export class Spinner {
    /**
     * The size of the spinner. Defaults to `default`.
     */
    public readonly size: InputSignal<SpinnerSize> = input<SpinnerSize>('default');
    
    /**
     * The theme of the spinner. Defaults to `default`.
     */
    public readonly theme: InputSignal<SpinnerTheme> = input<SpinnerTheme>('default');

    /**
     * Whether the track of the spinner should be shown. Defaults to `true`.
     */
    public readonly showTrack: InputSignal<boolean> = input<boolean>(true);
}